module.exports = __webpack_public_path__ + "img/envelope-dots.59950c07.png";